import { FormLabel, Select } from "@chakra-ui/react";
import { WidgetProps } from "@rjsf/utils";
import { useEffect, useState } from "react";

interface SelectItem {
  id: string;
  label: string;
  value?: string;
}
interface SelectOptions {
  items: SelectItem[];
  value?: string;
  triggerMoreItems?: (data: any) => void;
  itemsLoading?: boolean;
  inheritWidthOf?: "menu" | "target" | "none" | undefined;
  variant?: "readonly" | "readonly-icons" | "inline-listbox";
  selectTitle: string;
}

const CustomisedSelectWidget = (
  props: WidgetProps,
  {
    items,
    value,
    triggerMoreItems,
    itemsLoading,
    inheritWidthOf,
    variant,
    selectTitle
  }: SelectOptions
) => {
  console.log("items", items);
  console.log("value", value);
  console.log("itemsLoading", itemsLoading);
  const foundItem = items.find((item) => item.value === value);
  const initialValue = foundItem ? foundItem : "";
  const [selectValue, setSelectValue] = useState(initialValue);
  return (
    <div>
      <FormLabel>{selectTitle}</FormLabel>
      <Select
        // onLoad={}
        value={selectValue as string}
        placeholder={props.uiSchema?.["ui:placeholder"] || props.placeholder}
        onChange={(params) => {
          setSelectValue(params.target.value);
          props.onChange(params.target.value || "");
        }}
      >
        {items.map((item) => {
          return <option value={item.value as string}>{item.label}</option>;
        })}
      </Select>
    </div>
    // <Select
    //   options={items}
    //   value={initialValue}
    //   isLoading={itemsLoading}
    //   placeholder={props.uiSchema?.['ui:placeholder'] || props.placeholder}
    //   onChange={(params) => {
    //     props.onChange(params.value[0].value || '');
    //   }}
    // />
  );
};

export default CustomisedSelectWidget;
